import { createSelector } from "@reduxjs/toolkit";
import { Panel } from "components/Panel/Panel";
import { Track } from "model/Track/Track";
import { shallowEqual } from "react-redux";
import { nonUndefined } from "Utility";
import { TrackGridContainer } from "./styles";
import { TrackGridItem } from "./TrackGridItem";
import { useAppSelector } from "app/hooks";
import { RootState } from "app/store";

interface Props {
  trackIds: string[];
}

export const TrackGrid = ({ trackIds }: Props) => {
  const tracks = useAppSelector(
    (state) => selectTracksOrderedByName(state, trackIds),
    shallowEqual
  );

  return (
    <TrackGridContainer>
      {tracks.map((t) => (
        <Panel key={t.id} bottomMargin={false}>
          <TrackGridItem track={t} />
        </Panel>
      ))}
    </TrackGridContainer>
  );
};

const selectTracksOrderedByName = createSelector(
  [(state: RootState) => state.track.data, (_, trackIds: string[]) => trackIds],
  (tracks, trackIds) => {
    console.log(`Reselect Tracks By Name - ${trackIds.length}`);
    const filteredTracks: Track[] = nonUndefined(
      trackIds.map((id) => tracks[id])
    );

    return filteredTracks.sort((a, b) => a.name.localeCompare(b.name));
  }
);
